import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface FilterDrawerContextValue {
  open: boolean;
  toggle: () => void;
  close: () => void;
}

const FilterDrawerContext = createContext<FilterDrawerContextValue>({
  open: false,
  toggle: () => {},
  close: () => {},
});

export const useFilterDrawer = () => useContext(FilterDrawerContext);

export const FilterDrawerProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen((prev) => !prev), []);
  const close = useCallback(() => setOpen(false), []);
  return (
    <FilterDrawerContext.Provider value={{ open, toggle, close }}>
      {children}
    </FilterDrawerContext.Provider>
  );
};
